import { render } from "./FreebiesExplainerModal.vue?vue&type=template&id=6f8d6a5e&scoped=true"
import script from "./FreebiesExplainerModal.vue?vue&type=script&lang=js"
export * from "./FreebiesExplainerModal.vue?vue&type=script&lang=js"

import "./FreebiesExplainerModal.vue?vue&type=style&index=0&id=6f8d6a5e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f8d6a5e"]])

export default __exports__